import { FormOptionsModel } from "../../../data-model/formOptions";
import { getAllRelevantOptions } from "../../../utils/formOptions";
import { fetchOptionsFromPath, isDynamicPath } from "./refDocPathUtils";

export const replaceOptionsWithRefDocId = async (
  obj: any,
  allFormOptions: FormOptionsModel[],
): Promise<any> => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return Promise.all(
      obj.map((item) => replaceOptionsWithRefDocId(item, allFormOptions)),
    );
  }

  const result: Record<string, any> = {};
  let optionsResolved = false;

  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    const value = obj[key];

    if (key === "refDocId" && obj.refDocId) {
      result["options"] = getAllRelevantOptions(allFormOptions, obj.refDocId);
      result[key] = value;
      optionsResolved = true;
    } else if (
      key === "refDocPath" &&
      obj.refDocPath &&
      !obj.refDocId &&
      !optionsResolved
    ) {
      result[key] = value;
      if (!isDynamicPath(obj.refDocPath)) {
        result["options"] = await fetchOptionsFromPath(
          obj.refDocPath,
          obj.refDocFieldName,
        );
        optionsResolved = true;
      }
    } else if (key === "options" && !optionsResolved) {
      result[key] = value;
    } else if (key !== "options") {
      result[key] = await replaceOptionsWithRefDocId(value, allFormOptions);
    }
  }

  return result;
};
